import { createAction, props } from '@ngrx/store';

export const setLoading = createAction(
  '[Loading] Set Loading State',
  props<{ key: string; loading: boolean }>()
);

export const clearAllLoading = createAction('[Loading] Clear All Loading States');
